import * as z from "zod";

export const discardOptimizationJobDrafts = {
  name: "discardOptimizationJobDrafts" as const,
  input: z.object({ jobId: z.bigint() }),
  output: z.void(),
};
